// SimpleLayout.tsx
"use client";

import type { ReactNode } from "react";
import Image from "next/image";
import Link from "next/link";
import mainLogo from "@assets/icons/sidebar/main-logo.svg";
import { usePathname } from "next/navigation";
import { SiteFrame } from "@/components/layout/SiteFrame";

type SimpleLayoutProps = {
  children: ReactNode;
};

// paths (or path prefixes) that should NOT show the header
const NO_HEADER_PATHS = ["/partner-register"];
const NO_FOOTER_PATHS = ["/partner-register"];

export const SimpleLayout = ({ children }: SimpleLayoutProps) => {
  const pathname = usePathname();
  const showHeader = !NO_HEADER_PATHS.some((path) =>
    pathname?.startsWith(path),
  );
  const showFooter = !NO_FOOTER_PATHS.some((path) =>
    pathname?.startsWith(path),
  );

  return (
    <div className="flex min-h-screen min-w-0 flex-col">
      {showHeader && (
        <header className="fixed top-0 left-0 right-0 z-40 border-b bg-white/95 backdrop-blur-sm md:px-4 px-2">
          <SiteFrame outerClassName="py-3 h-auto  flex items-center">
            <Link
              href="/"
              aria-label="Go to homepage"
            >
              <Image
                src={mainLogo}
                alt="Tovtrip"
                width={48}
                height={48}
                priority
              />
            </Link>
          </SiteFrame>
        </header>
      )}

      <main className={showHeader ? "flex-1 pt-25 md:px-4 px-2" : "flex-1 "}>
        {children}
      </main>

      {showFooter && (
        <footer className="border-t">
          <div className="mx-auto flex h-[92px] w-full max-w-[1100px] items-end justify-center px-4">
            <p className="text-center text-sm text-[#464C53] py-6">
              © {new Date().getFullYear()} Tovtrip. All rights reserved.
            </p>
          </div>
        </footer>
      )}
    </div>
  );
};

export default SimpleLayout;
